import { render } from "./Prompt.vue?vue&type=template&id=28ecad94&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"

import "./Prompt.vue?vue&type=style&index=0&id=28ecad94&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ecad94"],['__file',"src/components/Prompt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28ecad94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28ecad94', __exports__)) {
    console.log('reload')
    api.reload('28ecad94', __exports__)
  }
  
  module.hot.accept("./Prompt.vue?vue&type=template&id=28ecad94&scoped=true", () => {
    console.log('re-render')
    api.rerender('28ecad94', render)
  })

}


export default __exports__